<template>
  <div class="my-3 d-flex shortcut-container justify-content-between d-md-none">
    <div class="d-flex flex-column align-items-center" @click="showContractionModal()">
      <contraction-svg></contraction-svg>
      <span>+ Contraction</span>
    </div>
    <div class="d-flex flex-column align-items-center" @click="showDreamLogPopup">
      <dream-svg></dream-svg>
      <span>+ Dream</span>
    </div>
    <router-link to="/meditation_dashboard">
      <div class="d-flex flex-column align-items-center">
        <meditation-svg></meditation-svg>
        <span>+ Meditation</span>
      </div>
    </router-link>
    <div class="d-flex flex-column align-items-center" @click="showDailyLogPopup">
      <dailylog-svg></dailylog-svg>
      <span>+ Daily log</span>
    </div>

    <b-modal id="modal-add-contraction" title="Add your contraction" hide-header hide-footer>

      <div class="d-flex flex-column">

        <b-form-textarea
          v-model="contraction"
          placeholder="Add your contraction"
          rows="6"
          class="mt-2"
          autofocus
        ></b-form-textarea>

        <div class="mt-3">
          <b-button class="btn btn-sm text-decoration-none" @click="saveContraction" :disabled="loading.save">
            Submit <b-spinner small v-if="loading.save"></b-spinner>
          </b-button>
          <b-button size="sm" variant="outline-secondary" @click="hideContractionPopup()">
            Close
          </b-button>
        </div>
      </div>

    </b-modal>

    <add-dream-log
      :readonly="0"
      status="add"
      :active-dream="dream"
      @submitted="hideDreamLogPopup"
      v-if="dream"
    ></add-dream-log>

    <add-feeling-log
      :readonly="0"
      modal_type="add"
      :feeling="{}"
      :feelings="feelings"
      :questions="questions"
      @onAction="onAddFeelingAction"
      v-if="showFeelingsPopup"
    ></add-feeling-log>
  </div>
</template>

<script>

import axios from 'axios';
import ContractionSvg from "@/components/svg/ContractionSvg";
import DreamSvg from "@/components/svg/DreamSvg";
import MeditationSvg from "@/components/svg/MeditationSvg";
import DailylogSvg from "@/components/svg/DailylogSvg";
import AddDreamLog from "@/components/dreams/AddDreamLog";
import {QUESTIONS, FEELINGS} from "@/components/feelings/data";
import AddFeelingLog from "@/components/feelings/AddFeelingLog";

export default {
  components: {
    DailylogSvg,
    MeditationSvg,
    DreamSvg,
    ContractionSvg,
    AddDreamLog,
    AddFeelingLog,
  },
  data() {
    return {
      contraction: '',
      loading: {
        save: false,
      },
      dream: null,
      showFeelingsPopup: false,

      feelings: FEELINGS,
      questions: QUESTIONS
    }
  },

  methods: {
    async showDailyLogPopup() {

      this.getLatestGoal()
        .then(() => {
          const questions = Object.values(this.questions);
          for (const key of questions) {
            if (key.id === "goal") {
              this.questions["goal"].value = this.goal_latest;
              this.questions["goal"].sanitised_value = this.goal_latest;
            }
          }
        })

      this.showFeelingsPopup = true
      this.$nextTick(() => {
        setTimeout(() => this.$bvModal.show('feelings_wrapper'), 100)
      })
    },


    onAddFeelingAction() {
      this.showFeelingsPopup = false
      this.$root.$emit('dailylog-saved')
    },

    showDreamLogPopup() {
      this.dream = {
        date_edit: (new Date).toISOString().split('T')[0],
        can_comment: true
      }
      this.$nextTick(() => {
        setTimeout(() => this.$bvModal.show('dream_wrapper'), 100)
      })
    },

    hideDreamLogPopup() {
      this.dream = null

      this.$root.$emit('dream-saved')
    },

    showContractionModal() {
      this.$bvModal.show('modal-add-contraction');
    },

    hideContractionPopup() {
      this.$bvModal.hide('modal-add-contraction');
    },

    saveContraction() {

      if (! this.contraction) {
        return
      }

      const params = new URLSearchParams();
      params.append("token", this.$store.state.session_id);
      params.append("contraction", this.contraction);

      this.loading.save = true
      axios({
        method: "post",
        url: this.$store.state.api_url + "contractions/store",
        data: params,
      })
        .then(() => {
          this.contraction = ''
          this.loading.save = false
          this.hideContractionPopup()
        })
    },

    getLatestGoal() {
      const params = new URLSearchParams();
      params.append("token", this.$store.state.session_id);
      params.append("category", "user_feelings_log");
      params.append("limit", "1");
      params.append("order_by", "access");
      params.append("order_direction", "desc");

      return axios({
        url: this.$store.state.api_url + "feelingsGet",
        params: params,
      })
        .then((response) => {
          this.goal_latest = response.data.goal;
        })
    }
  }
}

</script>

<style scoped>

.shortcut-container {
  gap: 4px;
  color: #d6b674;
  font-size: 9px;
}

.shortcut-container > div {
  cursor: pointer;
}

a {
  color: #d6b674;
}

a:hover {
  color: #d6b674;
  text-decoration: none;
}

</style>
